import map from 'lodash-es/map';
import React from 'react';
import { RadioButton, withFormikSupport } from '@fourthwall/components';
import { Label } from '../../components/Label/Label';
import * as S from './Radio.styled';
const RadioComponent = ({ data, value, onChange, onSettingUpdate }) => {
    const { id, label, options, info } = data;
    const handleChange = (e) => {
        if (onChange) {
            onChange(e);
        }
        onSettingUpdate(id, e.target.value);
    };
    const renderOptions = () => {
        return map(options, (option) => (React.createElement(S.RadioContainer, null,
            React.createElement(RadioButton, { checkedValue: option.value, label: option.label, value: value, onChange: handleChange }))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Label, { info: info }, label),
        renderOptions()));
};
export const Radio = withFormikSupport(RadioComponent);
